module.exports = __webpack_public_path__ + "img/treeplant4_7-8-2021.b52c71f2.jpg";